import React, { useState, useEffect } from 'react'
import { Box } from "grommet"

import { CSVLink } from "react-csv"
import { Download, Clipboard } from 'grommet-icons'

import { CircularButton } from "../common/CircularButton"
import { useToasts } from 'react-toast-notifications'
import * as beautify from "json-beautify"
import { csvToArray, DownloadTriageFile } from './TriageFile'

export const TopBar = ({ text }) => {

    // Copy Clipboard
    const copy = require('clipboard-copy')
    const { addToast } = useToasts()

    try {
        text = beautify(JSON.parse(text), null, 2, 80)
    } catch (err) {
        text = ""
    }

    const handleClick = () => {
        copy(text)
        addToast("Log Output Copied to ClipBoard", {
            appearance: 'success',
            autoDismiss: true,
            autoDismissTimeout: 2000
        })
    }

    return (

        <Box fill="horizontal" gap="xsmall">
            <Box fill="horizontal" flex={false} margin="xsmall" direction="row">
                <Box basis="98%" align="center" direction='row' justify='center'>
                </Box>
                {text &&
                    <Box basis="250px" align="center" direction='row' justify='center'>

                        <CSVLink data={text} filename="TriageLog.txt">
                            <CircularButton icon={<Download color="light-3" />} />
                        </CSVLink>
                        <CircularButton icon={<Clipboard color="light-3" />} handleClick={handleClick} />

                    </Box>
                }
            </Box>
        </Box>
    )
}

export const TopBarFile = ({ triageFileUrl }) => {

    // Copy Clipboard
    const copy = require('clipboard-copy')
    const { addToast } = useToasts()

    const csvFile = triageFileUrl.endsWith(".csv") ? true : false
    const resultFile = DownloadTriageFile(triageFileUrl)

    const [downloadedFile, setdownloadedFile] = useState(false)

    useEffect(() => {
        if (resultFile && resultFile.data) {
            setdownloadedFile(resultFile.data)
        }
    }, [resultFile, resultFile.data])

    useEffect(() => {
        if (downloadedFile && csvFile) {

            let tab_col_temp = []
            let data = csvToArray(downloadedFile)

            if (data.length > 0) {

                // Generate tab_col dynamically
                Object.keys(data[0]).forEach(h => {
                    tab_col_temp.push({
                        field: h,
                        headerName: h.capitalize()
                    })
                })

            }
        }
    }, [downloadedFile, csvFile])

    const handleClick = () => {
        copy(downloadedFile)
        addToast("Output Copied to ClipBoard", {
            appearance: 'success',
            autoDismiss: true,
            autoDismissTimeout: 2000
        })
    }

    return (

        <Box fill="horizontal" gap="xsmall">
            <Box fill="horizontal" flex={false} margin="xsmall" direction="row">
                <Box basis="98%" align="center" direction='row' justify='center'>
                </Box>
                {downloadedFile &&
                    <Box basis="250px" align="center" direction='row' justify='center'>
                        <CircularButton icon={<Clipboard color="light-3" />} handleClick={handleClick} />
                    </Box>
                }
            </Box>
        </Box>
    )
}